import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 pb-24 md:pb-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-12 sm:px-8 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <Logo size={34} />
          <div>
            <p className="font-display text-lg font-bold uppercase leading-none">
              Zaki Logistics LLC
            </p>
            <p className="mt-1 font-mono text-[10px] tracking-[0.3em] text-white/50">
              OMAHA, NEBRASKA
            </p>
          </div>
        </div>

        <p className="font-mono text-xs leading-relaxed text-white/50">
          6716 N 50th Ave, Omaha, NE 68152
          <br />
          402-639-1139 · Zakilogistics.ne@gmail.com
          <br />
          US DOT 3452744
        </p>

        <p className="font-mono text-[10px] text-white/35">
          © {new Date().getFullYear()} ZAKI LOGISTICS LLC
        </p>
      </div>
    </footer>
  );
}
